import { api } from './api';

export interface HealthSubtask {
  id: number;
  feature_id: number;
  title: string;
  status: 'pending' | 'in_progress' | 'done';
  sort_order: number;
}

export interface HealthBug {
  id: number;
  feature_id: number | null;
  title: string;
  severity: 'low' | 'medium' | 'high' | 'critical';
  status: 'open' | 'resolved';
  description?: string;
  category?: string;
  github_issue_url?: string;
  resolved_at?: string;
}

export interface HealthFeature {
  id: number;
  slug: string;
  title: string;
  description?: string;
  vision?: string;
  unresolved?: string;
  sort_order: number;
  subtasks: HealthSubtask[];
  bugs: HealthBug[];
  subtasks_total: number;
  subtasks_done: number;
  bugs_open: number;
}

export interface SystemHealthData {
  features: HealthFeature[];
  global_bugs: HealthBug[];
  bugs_open_total: number;
  bugs_total: number;
}

export const systemHealthApi = {
  getSummary: () => api.get<SystemHealthData>('/system-health'),

  createFeature: (data: Partial<HealthFeature>) => api.post<HealthFeature>('/system-health/features', data),
  updateFeature: (id: number, data: Partial<HealthFeature>) => api.patch<HealthFeature>(`/system-health/features/${id}`, data),
  deleteFeature: (id: number) => api.delete<{ ok: boolean }>(`/system-health/features/${id}`),

  createSubtask: (data: Partial<HealthSubtask>) => api.post<HealthSubtask>('/system-health/subtasks', data),
  updateSubtask: (id: number, data: Partial<HealthSubtask>) => api.patch<HealthSubtask>(`/system-health/subtasks/${id}`, data),
  deleteSubtask: (id: number) => api.delete<{ ok: boolean }>(`/system-health/subtasks/${id}`),

  createBug: (data: Partial<HealthBug>) => api.post<HealthBug>('/system-health/bugs', data),
  updateBug: (id: number, data: Partial<HealthBug>) => api.patch<HealthBug>(`/system-health/bugs/${id}`, data),
  deleteBug: (id: number) => api.delete<{ ok: boolean }>(`/system-health/bugs/${id}`),

  exportToGithub: (bugId: number) =>
    api.post<{ github_issue_url: string } | { already_exported: boolean; github_issue_url: string }>(
      `/system-health/bugs/${bugId}/export-github`
    ),

  seed: () => api.post<{ inserted: number; total: number }>('/system-health/seed'),
};
